import { render, staticRenderFns } from "./admin-multidemo-reset-dialog.vue?vue&type=template&id=7b3108b0&scoped=true&"
import script from "./admin-multidemo-reset-dialog.vue?vue&type=script&lang=js&"
export * from "./admin-multidemo-reset-dialog.vue?vue&type=script&lang=js&"
import style0 from "./admin-multidemo-reset-dialog.vue?vue&type=style&index=0&id=7b3108b0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b3108b0",
  null
  
)

export default component.exports